<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-4">
          <h6>Date</h6>
        </div>
        <div class="col-4">
          <h6>Price</h6>
        </div>
        <div class="col-4">
          <h6>Source</h6>
        </div>
      </div>
      <div class="row" v-for="dataPoint in propertyHistory.slice(0,5)" v-bind:key="dataPoint.date">
        <div class="col-4">
          <p>{{ formatDate(dataPoint.date) }}</p>
        </div>
        <div class="col-4">
          <p>${{ dataPoint.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
        </div>
        <div class="col-4">
          <p>NorthstarMLS</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    propertyHistory: Array
  },
  methods: {
    formatDate (timestamp) {
      let dateComponents = timestamp.split(/\D/)
      return dateComponents[1] + '/' + dateComponents[2] + '/' + dateComponents[0]
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/dropdowns/PropertyHistory.vue